<template>
    <div>
        <div style="display: flex;width:100%">
            <div style="margin-top: 10px;text-align: center;width:100%" class="tab">
                <el-card class="box-card">
                    <div>
                        <table>
                            <tr>
                                <td style="width:60px">{{ $t('getapi[1964]') }}：</td>
                                <td style="width:150px;">
                                    <el-input v-model="year" type="text" size="mini"></el-input>
                                </td>
                                <td>
                                    <el-button type="primary" size="mini" @click="search" style="margin-left: 8px">{{$t('getapi[1980]')}}</el-button>
                                </td>
                            </tr>
                        </table>
                    </div>
                </el-card>
                <el-card class="box-card">
                    <div>
                        <div id="main" :style="{ width: '100%', height: tableHeight + 'px' }"></div>
                    </div>
                </el-card>

            </div>
        </div>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    import echarts from 'echarts';
    import 'echarts-gl';
    export default {
        name: '4_purorderrate',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-200
            }
        },
        data() {
            return {
                charts: '',
                year: '',
                data: [],
            };
        },
        beforeDestroy(){
        },
        mounted: function () {
            let that = this;
            that.year = new Date().getFullYear()
        },
        methods: {
            search(){
                let that = this
                let parm = {
                    Code: that.year
                }
                let loadingInstance = Loading.service(Common.maskoption1);
                that.$http.urlpost('/Kpi/GetSoOrderRate', parm, function (res) {
                    if (res.Success == 1) {
                        that.data = res.DataContent.Table
                        let d = that.handle(that.data)
                        that.draw(d)
                    }
                    loadingInstance.close()
                });

            },
            // 处理数据
            handle(dataContent){
                let that = this
                let list = {
                    datax: [],
                    data: []
                }
                if (dataContent.length == 0) {
                    //alert('没有数据');
                    list.datax = ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
                    list.data = [0,0,0,0,0,0,0,0,0,0,0,0]
                } else {
                    for(let i = 0;i<dataContent.length;i++){
                        list.data = [...list.data,
                            dataContent[i].finish_percent.replaceAll('%','')
                        ]
                        list.datax = [...list.datax,
                            that.translate(dataContent[i].somonth)
                        ]
                    }
                }
                return list;
            },
            translate(val){
                if(val == 1){
                    return '一月'
                } else if(val == 2){
                    return '二月'
                } else if(val == 3){
                    return '三月'
                } else if(val == 4){
                    return '四月'
                } else if(val == 5){
                    return '五月'
                } else if(val == 6){
                    return '六月'
                } else if(val == 7){
                    return '七月'
                } else if(val == 8){
                    return '八月'
                } else if(val == 9){
                    return '九月'
                } else if(val == 10){
                    return '十月'
                } else if(val == 11){
                    return '十一月'
                } else if(val == 12){
                    return '十二月'
                } else {
                    return ''
                }
            },
            // 图标
            draw(list){
                let that = this;
                that.charts = echarts.init(document.getElementById("main"));
                let option = {
                    title: {
                        text: that.year+ "年度SO及时完工率",
                        x:'center',
                        y:'top',
                        textAlign:'left'
                    },
                    xAxis: {
                        type: 'category',
                        label: {
                            show: true,
                            position: 'insideRight'
                        },
                        data: list.datax
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            formatter: '{value} %'
                        },
                        max: 100
                    },
                    series: [{
                        data: list.data,
                        type: 'bar',
                        showBackground: true,
                        backgroundStyle: {
                            color: 'rgba(220, 220, 220, 0.8)'
                        },
                        itemStyle:{
                            normal:{
                                color:'#409eff'
                            }
                        },
                        label: {
                            normal: {
                                show: true,
                                position: 'top'
                            }
                        },
                    }]
                }
                that.charts.clear();
                that.charts.setOption(option);
            }
        }
    };
</script>

<style scoped lang="less">

</style>
